import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { useDash } from "@/components/dashboard/Layout";
import { PageHead, Card, StatusPill, Stat } from "@/components/dashboard/kit";
import { api } from "@/lib/api";
import { PACKAGES, inr } from "@/data/content";

export function Team() {
  const [refs, setRefs] = useState(null);
  useEffect(() => { api.get("/me/referrals").then((r) => setRefs(r.data)); }, []);
  const list = refs || [];
  return (
    <div data-testid="team-page">
      <PageHead title="My" highlight="Team" sub="Everyone who created an ID with your link." />
      <div className="grid grid-cols-3 gap-4 mb-6">
        <Stat testid="team-total" label="Joined" value={list.length} />
        <Stat testid="team-approved" label="Approved" value={list.filter((r) => r.status === "approved").length} />
        <Stat testid="team-pending" label="Pending" value={list.filter((r) => r.status === "pending").length} />
      </div>
      <Card>
        {!list.length ? <p className="text-sm text-[var(--muted)]">No one has joined with your link yet.</p> : (
          <div className="divide-y divide-[var(--surface-border)]">
            {list.map((r, i) => (
              <div key={i} data-testid={`my-referral-${i}`} className="flex items-center justify-between py-3 text-sm">
                <div><p className="font-semibold">{r.name}</p><p className="text-xs text-[var(--muted)]">{new Date(r.created_at).toLocaleDateString("en-IN")} · {PACKAGES.find((p) => p.slug === r.package)?.name || "—"}</p></div>
                <StatusPill status={r.status} />
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}

export function Leaderboard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/leaderboard").then((r) => setRows(r.data)); }, []);
  return (
    <div data-testid="leaderboard-page">
      <PageHead title="Top" highlight="Partners" sub="Learners who brought the most approved members to Ilmora." />
      <Card>
        {!rows.length ? <p className="text-sm text-[var(--muted)]">The leaderboard fills up as partners earn their first commissions.</p> : rows.map((r, i) => (
          <div key={r.code} data-testid={`leader-row-${i}`} className="flex items-center gap-4 py-3 border-b last:border-0 border-[var(--surface-border)]">
            <span className={`w-9 h-9 rounded-full grid place-items-center font-bold text-sm ${i < 3 ? "text-[var(--on-accent)]" : "glass"}`} style={i < 3 ? { background: "var(--btn-bg)" } : undefined}>{i < 3 ? <Trophy size={15} /> : i + 1}</span>
            <p className="font-semibold flex-1">{r.name}</p>
            <p className="text-xs text-[var(--muted)]">{r.count} joined</p>
            <p className="font-bold text-[var(--pink)] w-24 text-right">{inr(r.amount)}</p>
          </div>
        ))}
      </Card>
    </div>
  );
}
